e.A.website_url = {
	url_ : {},

	init : function(){
		this._url = $( '[data-js="edspire/account/website-url"]' );
		if( this._url.length > 0 ){
			this._clipboard();
		}
	},

	_clipboard : function(){
		var clip = new Clipboard( '[data-js="edspire/account/website-url"]' );
		clip.on( 'success', function( e ){
			this._url.text( 'Copied' );
			this._url.addClass( 'copied' );
		}.bind( this ) );
	}
};